import React from 'react';
import LangIcon from './LangIcon';
import { dummyClick } from '../utilities';

const LanguagesMenu = ({
  opened, languageSelected, onToggleClick, onChangeClick
}) => (
  <div className="a-header-language-menu line-height-9 relative a-font-size-1 right xs-hide mr3">
    <div className="inline-block mr2 line-height-6">
      <LangIcon lang={languageSelected} onClick={onToggleClick} />
    </div>
    <div className={`a-header-language-menu-list ${opened ? 'opened' : ''}`}>
      <ul className="list-reset m0 p3 bg-black-2 line-height-6">
        <li className="line-height-4 mb1">
          <LangIcon lang="en" onClick={event => onChangeClick(event, 'en')} />
        </li>
        <li className="line-height-4">
          <LangIcon lang="de" onClick={event => onChangeClick(event, 'de')} />
        </li>
      </ul>
    </div>
  </div>
);

LanguagesMenu.defaultProps = {
  opened: false,
  languageSelected: 'en',
  onToggleClick: dummyClick,
  onChangeClick: dummyClick
};

export { LanguagesMenu };
